import { Button } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DataTablePagination from "../../components/Table/DataTablePagination.jsx";
import { getAllServicesService } from "../../services/servicesServices.js";
import EmailAndPhone from "../Users/additionFields/EmailAndPhone.jsx";
import Actions from "./additionFields/Actions.jsx";
import ServiceImage from "./additionFields/ServiceImage.jsx";
import Status from "./additionFields/Status.jsx";

const options = [
  {
    text: "همه سرویس‌ها",
    value: "",
  },
  {
    text: "سرویس‌های جاری",
    value: "o",
  },
  {
    text: "سرویس‌های تایید شده",
    value: "a",
  },
  {
    text: "سرویس‌های رد شده",
    value: "r",
  },
  {
    text: "سرویس‌های منقضی",
    value: "e",
  },
  {
    text: "در حال تحلیل",
    value: "an",
  },
  {
    text: "در انتظار تایید پارامتر ها",
    value: "wp",
  },
  {
    text: "در انتظار تایید کارشناس",
    value: "op",
  },
];

const ServicesPage = () => {
  const [forceRequest, setForceRequest] = useState(0);

  const navigate = useNavigate();

  const servicesCols = [
    {
      field: "code",
      text: "کد سرویس",
    },
    {
      field: null,
      text: "ایمیل / شماره تلفن مشتری",
      element: (rowData) => <EmailAndPhone rowData={rowData.customer} />,
    },
    {
      field: null,
      text: "تصویر سرویس",
      element: (rowData) => (
        <ServiceImage rowData={rowData} scrollQuery="#div-content" />
      ),
    },
    {
      field: null,
      text: "وضعیت",
      element: (rowData) => <Status rowData={rowData} />,
    },
    {
      field: null,
      text: "جزئیات مشتری",
      element: (rowData) => {
        return (
          <Button
            variant="contained"
            onClick={() =>
              navigate("/services/user", {
                state: rowData,
              })
            }
          >
            اطلاعات مشتری
          </Button>
        );
      },
    },
    {
      field: null,
      text: "جزئیات سرویس",
      element: (rowData) => {
        return (
          <Button
            variant="contained"
            color="success"
            onClick={() =>
              navigate("/services/service", {
                state: rowData,
              })
            }
          >
            اطلاعات سرویس
          </Button>
        );
      },
    },
    {
      field: null,
      text: "صفحه سرویس",
      element: (rowData) => {
        return (
          <Button
            variant="contained"
            color="success"
            onClick={() =>
              window.open(
                `http://app.wisercam.com/DetailOrder/${rowData.code}`
              )
            }
          >
            مشاهده
          </Button>
        );
      },
    },
    {
      field: null,
      text: "عملیات‌ها",
      element: (rowData) => <Actions rowData={rowData} />,
    },
  ];

  return (
    <DataTablePagination
      tableCols={servicesCols}
      title={"سرویس‌ها"}
      APIFunction={getAllServicesService}
      dataField={"services"}
      hasOutlet={true}
      hasCatergory={true}
      categoryOptions={options}
      forceRequest={forceRequest}
      setForceRequest={setForceRequest}
    ></DataTablePagination>
  );
};

export default ServicesPage;
